import { SALES_ORDER_PAGE } from "routes/route.constant";
import SalesOrder from "./SalesOrder";

const route = {
  path: SALES_ORDER_PAGE,
  element: SalesOrder,
};

export default route;
